import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FirstLoginResponse } from '../../interfaces/first-login.interface';
import { Global } from '../global';

@Injectable({
  providedIn: 'root'
})
export class FirstLoginService {

  private API_URL: string;

  constructor(private httpClient: HttpClient) {
    this.API_URL = Global.url+'/cx/firstlogin'
  }

  getUrlFirstLogin(token: string, request: any): Observable<FirstLoginResponse> {
    return this.httpClient.post<FirstLoginResponse>(this.API_URL, request , {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'        
      }
    });
  }
}
